import { trainingApiClient } from "../../../../../http-common";

export const getAllGroupList = async (obj) => {
  return await trainingApiClient.post(`/masters/Group/getGroupList`, obj);
};
export const getDepartmentDropdown = async (id) => {
  return await trainingApiClient.get(`/masters/unit/unitDepartmentMappingDropdown`, {
    params: {
      unitId: id,
    },
  });
};

export const getEmployeeDropdown = async (departmentId) => {
  return await trainingApiClient.get(
    `/masters/unit/departmentEmployeeMappingDropdown`,
    {
      params: {
        departmentId,
      },
    },
  );
};

export const getGroupMasterInfo = async (id) => {
  return await trainingApiClient.get(`/masters/Group/getGroupData`, {
    params: {
      groupId: id,
    },
  });
};

export const getUnitDropdown = async () => {
  return await trainingApiClient.get(`/masters/unit/unitDropDown`);
};

export const saveGroup = async (obj) => {
  return await trainingApiClient.post(`/masters/Group/save`, obj);
};